<template>
    <div class="section-listGame CategoryGames" v-show="isLocaleAllowed && games.length">
        <div class="section-listGame__header">
            <div class="title">
                <img ref="image" :src="categoryImage" :alt="categoryTitle"/>
                <div class="title__text">
                    <h2 v-text="categoryTitle"/>
                    <p v-html="categoryDescription"/>
                </div>
            </div>
            <div class="link">
                <router-link :to="categoryPageUrl">
                    <span>{{ $t('front.game.button.see_all') }} <span v-show="totalGamesCount">{{
                            totalGamesCount
                        }}</span></span>
                    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L6 6L1 1" stroke="#926D20"/>
                    </svg>
                </router-link>
            </div>
        </div>

        <component
            ref="categoryGamesComponent"
            :is="componentName"
            :items="games"
            :show-load-more-button="showLoadMoreButton"
            :loadMoreDesktopRowsCount="loadMoreDesktopRowsCount"
            :loadMoreMobileRowsCount="loadMoreMobileRowsCount"
            :total-items-count="totalGamesCount"
            :additional-game-rows-count="additionalGameRowsCount"
            :category-id="categoryId"
            :virtual-category-interface-id="virtualCategoryInterfaceId"
            :recommendation-id="vendorRecommendationId"
            v-if="componentName"/>
    </div>
</template>

<script>
const componentsGamesCount = {
    GamesBlockSimple: {
        maxBaseRowsGamesCount: 5,
        maxAdditionalRowsGamesCount: 5,
    },
    GamesBlockWithWinnersList: {
        maxBaseRowsGamesCount: 8,
        maxAdditionalRowsGamesCount: 5,
    },
    GamesBlockWithBigLeftItem: {
        maxBaseRowsGamesCount: 8,
        maxAdditionalRowsGamesCount: 5,
    },
    GamesBlockWithBigRightItem: {
        maxBaseRowsGamesCount: 8,
        maxAdditionalRowsGamesCount: 5,
    },
    ThreeGamesBlockWithBigLeftItem: {
        maxBaseRowsGamesCount: 3,
        maxAdditionalRowsGamesCount: 4,
    },
};

import apiData from "../../../../mixins/apiData";
import categoryGame from "../../../../mixins/categoryGame";
import categoryGamesData from "../../../../mixins/categoryGamesData";

export default {
    name: "CategoryGames",

    mixins: [apiData, categoryGame, categoryGamesData],

    props: ['items', 'isOnlyForUser', 'settings'],

    serverPrefetch() {
        return this.category && this.fetchData() || Promise.resolve();
    },

    mounted() {
        this.category && this.fetchData();
    },

    watch: {
        user(user, oldUser) {
            // reload games on change user (apply restrictions)
            if ((user && !oldUser || !user && oldUser)) {
                this.category && this.fetchData();
            }
        }
    },

    computed: {
        componentName() {
            return this.settings && this.settings.appearance_component;
        },

        startGamesCount() {
            return componentsGamesCount[this.componentName].maxBaseRowsGamesCount + componentsGamesCount[this.componentName].maxAdditionalRowsGamesCount * this.settings.additional_game_rows_count;
        },

        isLocaleAllowed() {
            return this.category && this.category.isLocaleAllowed;
        },

        user() {
            return this.$store.state.user;
        },

        category() {
            return Array.isArray(this.items) && this.items.length && this.items[0];
        },

        categoryId() {
            return this.category && this.category.id;
        },

        virtualCategoryInterfaceId() {
            return this.category && this.category.virtualCategoryInterfaceId;
        },

        categoryImage() {
            return this.category && this.category.image;
        },

        categoryTitle() {
            return this.category && this.category.title;
        },

        categoryDescription() {
            return this.category && this.category.description;
        },

        categoryPageUrl() {
            return this.category && this.category.pageUrl;
        },

        showLoadMoreButton() {
            return this.settings.load_more_button && this.hasMoreGames;
        },

        additionalGameRowsCount() {
            let additionalGameRowsCount = parseInt(this.settings.additional_game_rows_count);
            return Number.isInteger(additionalGameRowsCount) ? additionalGameRowsCount : 0;
        },

        loadMoreDesktopRowsCount(){
            let count = parseInt(this.settings.load_more_desktop_rows_count);
            return Number.isInteger(count) ? count : 0;
        },

        loadMoreMobileRowsCount(){
            let count = parseInt(this.settings.load_more_mobile_rows_count);
            return Number.isInteger(count) ? count : 0;
        },
    },

    methods: {
        fetchData() {
            return new Promise((resolve) => {
                let data = this.createApiData(this.createFetchGamesData(this.startGamesCount, 0));

                this.$store.dispatch('FETCH_CATEGORY_GAMES_BY_ID', data)
                    .then(gamesData => {
                        this.setGamesData(gamesData, false, false);

                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/categoryGames/CategoryGames"
</style>